/** 根据当前站点 regionId / regionCode 解析对应国家信息 */
export const resolveCurrentRegion = (
  regions: region.IRegionItem[] = [],
): region.IRegionItem | undefined => {
  if (!regions.length) {
    return undefined
  }

  const regionId = Number(useCurrentCountry().value)
  const regionCode = (useCurrentCountryCode().value || 'KE').toUpperCase()

  return regions.find((c) => c.id === regionId)
    || regions.find((c) => (c.code || '').toUpperCase() === regionCode)
    || regions.find((c) => c.isPrimaryDomain)
    || regions[0]
}

/** 登录/注册/绑定场景可选国家：与登录页一致，展示全部国家 */
export const getSelectableRegions = (
  regions: region.IRegionItem[] = [],
): region.IRegionItem[] => regions
